import { Goal } from '../../../goals';
import { GoalType } from '../../../graphql/generated';
import { BABY } from './baby';
import { CAR } from './car';
import { CASH_MANAGEMENT } from './cashManagement';
import { COLLEGE } from './college';
import { CUSTOM } from './custom';
import { DAYCARE } from './daycare';
import { EMERGENCY_FUND } from './emergencyFund';
import { GENERAL_INVESTING } from './generalInvesting';
import { HOME_DOWN_PAYMENT } from './homeDownPayment';
import { PAY_OFF_DEBT } from './payOffDebt';
import { RETIREMENT } from './retirement';
import { BaseGoalConfig } from './types';
import { VACATION } from './vacation';
import { WEDDING } from './wedding';

export const baseConfigByGoalType: Record<GoalType, BaseGoalConfig<any>> = {
    CASH_MANAGEMENT,
    GENERAL_INVESTING,
    HOME_DOWN_PAYMENT,
    EMERGENCY_FUND,
    PAY_OFF_DEBT,
    VACATION,
    COLLEGE,
    CAR,
    WEDDING,
    BABY,
    DAYCARE,
    RETIREMENT,
    CUSTOM,
};

export const getGoalBaseConfig = <TGoal extends Goal>(
    goalType: TGoal['type']
): BaseGoalConfig<TGoal> => baseConfigByGoalType[goalType];

export * from './types';
